import React from "react";
import aboutImg from "../assets/about.jpg";

const About = () => {
  const sectionStyle = {
    padding: "3.5rem 0",
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "16px",
    padding: "1.5rem 1.7rem",
    border: "1px solid #e5e7eb",
    boxShadow: "0 10px 25px rgba(15, 23, 42, 0.08)",
  };

  const headingStyle = {
    marginTop: 0,
    fontSize: "1.85rem",
    marginBottom: "0.5rem",
  };

  const paragraphStyle = {
    margin: "0.25rem 0",
    fontSize: "1.2rem",
    color: "#4b5563",
  };

  return (
    <section id="about" style={sectionStyle}>
      <div className="container">

        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <h2 style={{ fontSize: "1.7rem", fontWeight: 700 }}>Our Mission</h2>
          <p style={{ fontSize: "0.96rem", color: "#4b5563", maxWidth: "50rem", margin: "0.2rem auto" }}>
            We are dedicated to advancing environmental sustainability through innovative recycling solutions that transform waste into high-performance, eco-friendly materials.
          </p>
        </div>

        <div className="grid-2">
          <div style={cardStyle}>
            <h3 style={headingStyle}>Transforming waste into value</h3>
            <p style={paragraphStyle}>
              Our mission is to convert industrial, construction and plastic waste into high-quality eco-friendly materials that support a greener, circular economy.
            </p>
          </div>

          <div>
            <img src={aboutImg} alt="Eco Friendly Process" className="about-image" />
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;
